import React, { createContext, useContext, useState, useEffect } from 'react';

import { apiFetchProjectListData, apiFetchProjectTaskListData, apiLoginUser
            , apiFetchProjectTaskProgressData, apiSaveProjectTaskProgressData
            , apiLoadEwtData
            , apiSaveEmployeeWorkedTime
            , apiSaveProjectFoto
            , apiLoadWeather
            , apiSaveWeather
            , wsLogErr
         } from "./ws_calls.js";
import { getRegUserInfo, getUserId, getUserName, getUserIsa, 
            setRegUserCookie, setAnnUserCookie, eraseCookie, 
            regUserCookieName } from "./cookies.js"

import { ga } from "../utils/ga"

import dlog from '../utils/log'
const ctx = "store.js";
const ddlog = (msg) => { dlog(ctx,msg); }

//------------------------------------------------------------------
const AppDataContext = createContext([]);
const UiContext = createContext(null);

//------------------------------------------------------------------
//
//------------------------------------------------------------------
//const API_RESULT_OK = '1';
//const API_RESULT_YES = '1';

//------------------------------------------------------------------
// data operation status
//------------------------------------------------------------------
export const DATA_OP_STATUS_NONE = 0;
export const DATA_OP_STATUS_INPROGRESS = 1;
export const DATA_OP_STATUS_FAIL = 2;
export const DATA_OP_STATUS_OK = 3;

//------------------------------------------------------------------
// user operation status
//------------------------------------------------------------------
export const USER_OP_STATUS_NONE = 0;
export const USER_OP_STATUS_INPROGRESS = 1;
export const USER_OP_STATUS_FIN_OK = 2;
export const USER_OP_STATUS_LOGIN_FAIL = 3;

const logErr = (errtxt) => {
    (async () => await wsLogErr(errtxt))();
}

//------------------------------------------------------------------
// app data operations
//------------------------------------------------------------------
export function AppDataProvider(props) {
    //======================================================================
    //======================================================================
    const [ds_isLoading, setLoading] = useState(false);

    const [ds_projects, setProjects] = useState([]);
    const [ds_nonConProjects, setNonConProjects] = useState([]);

    const [ds_currentProjectId, ds_setCurrentProjectId] = useState(0);
    const [triggerProjectTasksLoad, startProjectTasksLoad] = useState(new Date());
    const ds_startProjectTasksLoad = () => startProjectTasksLoad(new Date());
    const [ds_projectTasks, ds_setProjectTasks] = useState([]);
    const [ds_currentTaskId, ds_setCurrentTaskId] = useState(0);
    const [ds_currentTask, setCurrentTask] = useState();
    const [currentTaskProgress, setCurrentTaskProgress] = useState({work_amnt:0, material_amnt:0, material_in_amnt:0});
    const ds_setCurrentTaskProgress = (amnt1,amnt2,amnt3) => { setCurrentTaskProgress({work_amnt:amnt1, material_amnt:amnt2, material_in_amnt:amnt3});}
    const [ds_currentDate, ds_setCurrentDate] = useState();
    const [triggerTaskProgressLoad, startTaskProgressLoad] = useState(new Date());
    const ds_startTaskProgressLoad = () => startTaskProgressLoad(new Date());
    const [triggerEwtLoad, startEwtLoad] = useState(new Date());
    const ds_startEwtLoad = () => startEwtLoad(new Date());
    const [ds_employeeWorkedTime, setEmployeeWorkedTime] = useState(null);

    const [currentDateEmployeeWorkedTime, ds_setCurrentDateEmployeeWorkedTime] = useState();

    const [ds_fotoCatId, ds_setFotoCatId] = useState();

    // current open dialog, needed to track on "back"
    const [ds_dialogOpen, ds_setDialogOpen] = useState(null);

    //======================================================================
    // USER data
    //======================================================================
    const [currentUser, setCurrentUser] = useState({username:'',password:'',anonymous:true,newuser:true});

    const [ds_loggedinUser, setLoggedinUser] = useState({id:null,name:null,anonymous:true,admin:false});
    const ds_logoutCurrentUser = () => { 
        ds_resetUserOperationStatus();
        setLoggedinUser({id:null,name:null,anonymous:true,admin:false});
        setCurrentUser({username:'',password:'',guser:false,fbuser:false,anonymous:true,newuser:false});
    }
    const ds_loginUser = (uname, upass) => { setCurrentUser({username:uname,password:upass,anonymous:false,newuser:false}); }
    const [ds_userOperationStatus, setUserOperationStatus] = useState(0);
    const ds_resetUserOperationStatus = () => { setUserOperationStatus(USER_OP_STATUS_NONE); }

    const ds_crrUserIsAdmin = () => { return ds_loggedinUser.id !== null && ds_loggedinUser.admin === true; }
    const ds_isLoggedIn = () => { 
        var rc = ds_loggedinUser.id !== null && ds_loggedinUser.anonymous === false; 
        return rc;
    }
    const [ds_travelProjectInfo, _setTravelProjectInfo] = useState({projectid:0,taskid:0});
    const setTravelProjectInfo = (pid,tid) => _setTravelProjectInfo({projectid:pid,taskid:tid});
    const [ds_educationProjectInfo, _setEducationProjectInfo] = useState({projectid:0,taskid:0});
    const setEducationProjectInfo = (pid,tid) => _setEducationProjectInfo({projectid:pid,taskid:tid});

    //-----------------------------------------
    const [firstShow, setFirstShow] = useState(true);

    //------------------------------------------------------------------
    // autologin on page load - use cookie
    //------------------------------------------------------------------
    const autologin = () => {
        var au = getRegUserInfo();
        if (au !== null) {
            ddlog("~~~~~~~ AUTOLOGIN: "+au);
            setLoggedinUser({id:getUserId(au),name:getUserName(au),anonymous:false,admin:getUserIsa(au)});
        }
        return false;
    }

    //-----------------------------------------
    //-----------------------------------------
    if (firstShow) {
        autologin();
        setFirstShow(false);
    }
    
    //-----------------------------------------
    // operation status to report back
    //-----------------------------------------
    const [ds_lastError, setLastError] = useState("");
    const [ds_dataOperationStatus, setDataOperationStatus] = useState(DATA_OP_STATUS_NONE);
    const ds_resetDataOperationStatus = () => { setDataOperationStatus(DATA_OP_STATUS_NONE); }

    //-----------------------------------------
    // fetch main screen data: project list
    // trigger: ds_loggedinUser
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;

            setLoading(true);
            setDataOperationStatus(USER_OP_STATUS_INPROGRESS);

            try {
                const data = await apiFetchProjectListData(ds_loggedinUser.id); 
                setProjects(data['prjts']);
                setNonConProjects(data['nonconprjts']);
                setTravelProjectInfo(data["travel_project_id"],data["travel_task_id"]);
                setEducationProjectInfo(data["education_project_id"],data["education_task_id"]);
                setDataOperationStatus(DATA_OP_STATUS_OK);

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                setDataOperationStatus(DATA_OP_STATUS_FAIL);
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [ds_loggedinUser]);

    //-----------------------------------------
    // fetch project data
    // trigger: triggerProjectTasksLoad
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;

            setLoading(true);
            setDataOperationStatus(USER_OP_STATUS_INPROGRESS);

            try {
                const data = await apiFetchProjectTaskListData(ds_loggedinUser.id, ds_currentProjectId); 
                ds_setProjectTasks(data);
                setDataOperationStatus(DATA_OP_STATUS_OK);

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                setDataOperationStatus(DATA_OP_STATUS_FAIL);
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [triggerProjectTasksLoad]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    // fetch project task progress data
    // trigger: triggerTaskProgressLoad
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentTaskId === null || ds_currentTaskId === 0) return;
            if (ds_currentDate === null) return;

            setCurrentTask(null);

            setLoading(true);
            try {
                const data = await apiFetchProjectTaskProgressData(ds_loggedinUser.id, ds_currentProjectId, ds_currentTaskId, ds_currentDate); 
                setCurrentTask(data);

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [triggerTaskProgressLoad]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    // save project task progress data
    // trigger: currentTaskProgress
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (ds_currentTaskId === null || ds_currentTaskId === 0) return;
            if (ds_currentDate === null) return;

            setLoading(true);
            try {
                await apiSaveProjectTaskProgressData(ds_loggedinUser.id, ds_currentProjectId, ds_currentTaskId, ds_currentDate
                                            , currentTaskProgress.work_amnt, currentTaskProgress.material_amnt, currentTaskProgress.material_in_amnt); 

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [currentTaskProgress]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    // load employee worked time data
    // trigger: triggerEwtLoad
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (ds_currentTaskId === null || ds_currentTaskId === 0) return;
            if (ds_currentDate === null) return;
            if (triggerEwtLoad === null) return;

            setEmployeeWorkedTime(null);

            setLoading(true);
            try {
                const data = await apiLoadEwtData(ds_loggedinUser.id, ds_currentProjectId, ds_currentTaskId, ds_currentDate); 
                setEmployeeWorkedTime(data);

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [triggerEwtLoad]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    // save project task employee worked time
    // trigger: currentTaskProgress
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (ds_currentTaskId === null || ds_currentTaskId === 0) return;
            if (currentDateEmployeeWorkedTime === null) return;

            setLoading(true);
            try {
                await apiSaveEmployeeWorkedTime(ds_loggedinUser.id, ds_currentProjectId, ds_currentTaskId, ds_currentDate
                                            , currentDateEmployeeWorkedTime); 

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [currentDateEmployeeWorkedTime]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    //-----------------------------------------
    const [currentProjectFotoInfo, setCurrentProjectFotoInfo] = useState({fcat:'',fdate:'',fcomment:'',fnonworktime:'',fotob64:'',fotow:0,fotoh:0});
    const ds_setCurrentProjectFotoInfo = (fcat,fdate,fcomment,fnonwtime,fb64,w,h) => 
                setCurrentProjectFotoInfo({fcat:fcat,fdate:fdate,fcomment:fcomment,fnonworktime:fnonwtime,fotob64:fb64,fotow:w,fotoh:h});

    //-----------------------------------------
    // save project foto 
    // trigger: currentProjectFotoInfo
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (currentProjectFotoInfo === null) return;

            setLoading(true);
            setDataOperationStatus(USER_OP_STATUS_INPROGRESS);
            
            logErr("will try to save foto... foto size: ("+currentProjectFotoInfo.fotow+" x "+currentProjectFotoInfo.fotoh+") bytes: "+currentProjectFotoInfo.fotob64.length);
            setLastError("");

            try {
                await apiSaveProjectFoto(ds_loggedinUser.id, ds_currentProjectId
                                            , currentProjectFotoInfo.fcat
                                            , currentProjectFotoInfo.fdate
                                            , currentProjectFotoInfo.fcomment
                                            , currentProjectFotoInfo.fnonworktime
                                            , currentProjectFotoInfo.fotob64
                                            ); 
                setDataOperationStatus(DATA_OP_STATUS_OK);
            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                setDataOperationStatus(DATA_OP_STATUS_FAIL);
                logErr(e.message);
                setLastError(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [currentProjectFotoInfo]);// eslint-disable-line react-hooks/exhaustive-deps

    //-----------------------------------------
    //-----------------------------------------
    const [ds_projectWeatherList, setProjectWeatherList] = useState([]);
    const [triggerWeatherLoad, startWeatherLoad] = useState(new Date());
    const ds_startWeatherLoad = () => startWeatherLoad(new Date());

    //-----------------------------------------
    // load project weather data
    // trigger: triggerWeatherLoad
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (triggerWeatherLoad === null) return;

            setEmployeeWorkedTime(null);
            setDataOperationStatus(DATA_OP_STATUS_INPROGRESS);

            setLoading(true);
            try {
                const data = await apiLoadWeather(ds_loggedinUser.id, ds_currentProjectId); 
                setProjectWeatherList(data);
                setDataOperationStatus(DATA_OP_STATUS_OK);

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                setDataOperationStatus(DATA_OP_STATUS_FAIL);
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [triggerWeatherLoad]);// eslint-disable-line react-hooks/exhaustive-deps


    //-----------------------------------------
    //-----------------------------------------
    const [currentWeather, setCurrentWeather] = useState(
                            {weather_id:0, weather_date:0, weather_time:0
                                , surface_temp:0, air_temp:0, humidity:0
                                , above_dew:0, weather_comment:""});
    const ds_setCurrentWeather = (wid,wdt,wtm,stemp,atemp,hmdt,adew,wcom) => { 
                setCurrentWeather(
                            {weather_id:wid, weather_date:wdt, weather_time:wtm
                                , surface_temp:stemp, air_temp:atemp, humidity:hmdt
                                , above_dew:adew, weather_comment:wcom});
                        }

    //-----------------------------------------
    // save project weather data
    // trigger: currentWeather
    //-----------------------------------------
    useEffect(() => {
        async function fetch() {
            if (ds_loggedinUser === null || ds_loggedinUser.id === null) return;
            if (ds_currentProjectId === null || ds_currentProjectId === 0) return;
            if (currentWeather === null) return;

            setLoading(true);
            try {
                await apiSaveWeather(ds_loggedinUser.id, ds_currentProjectId
                                        , currentWeather.weather_id
                                        , currentWeather.weather_date
                                        , currentWeather.weather_time
                                        , currentWeather.surface_temp
                                        , currentWeather.air_temp
                                        , currentWeather.humidity
                                        , currentWeather.above_dew
                                        , currentWeather.weather_comment); 

            } catch(e) {
                ga('general','api-fetch-data-fail');                
                if (e) ddlog("Error during data fetch: "+e);
                else ddlog("Error during data fetch.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [currentWeather]);// eslint-disable-line react-hooks/exhaustive-deps

    //======================================================================
    // USER functions
    //======================================================================

    //------------------------------------------------------------------
    // login user
    //------------------------------------------------------------------
    useEffect(() => { 
        async function fetch() {
            if (currentUser === null || currentUser.username === '') return;

            // ddlog("~~~ UserProvider::useEffect: register or login currentUser: ");
            // ddlog(currentUser);
            
            setUserOperationStatus(USER_OP_STATUS_INPROGRESS);
            //setLoggedinUser({id:null,name:null,admin:false});

            setLoading(true);
            try {
                const data = await apiLoginUser(currentUser.username, currentUser.password); 
                ddlog(data);
                setUserOperationStatus(USER_OP_STATUS_FIN_OK);
                setLoggedinUser({id:data.id, name:currentUser.username, admin:false, anonymous:false});
            } catch(e) {
                ga('general','login-usr-fail');
                setUserOperationStatus(USER_OP_STATUS_LOGIN_FAIL);
                if (e) ddlog("Error during login: "+e);
                else ddlog("Error during login.");
                logErr(e.message);
            }
            setLoading(false);
        };
        fetch();
    }, [currentUser]);// eslint-disable-line react-hooks/exhaustive-deps
    
    //------------------------------------------------------------------
    //------------------------------------------------------------------
    useEffect(() => {
        ddlog("~~~~ set auto login:");
        ddlog(ds_loggedinUser);
        if (ds_loggedinUser.id !== null) {
            setAutologin(true, ds_loggedinUser.id, ds_loggedinUser.name, ds_loggedinUser.admin, ds_loggedinUser.anonymous);
        } else {
            setAutologin(false);
        }
    }, [ds_loggedinUser]);

    //------------------------------------------------------------------
    // setAutologin - set cookie after successfull login
    //------------------------------------------------------------------
    const setAutologin = (enable, id, name, isa, ann) => {
        if (enable) {
            if (ann) setAnnUserCookie(name,id);
            else setRegUserCookie(name,id,isa);
        }
        else
            eraseCookie(regUserCookieName);
    }

    //======================================================================
    //======================================================================

    return <AppDataContext.Provider 
                value={{ds_isLoading, ds_travelProjectInfo, ds_educationProjectInfo,
                    ds_projects, ds_nonConProjects, ds_projectTasks, ds_setProjectTasks, ds_currentProjectId, 
                    ds_currentTaskId, ds_currentDate, ds_fotoCatId, ds_currentTask,
                    ds_setCurrentProjectId, ds_setCurrentTaskId, ds_setCurrentDate, ds_setFotoCatId,
                    ds_setCurrentTaskProgress, ds_startEwtLoad, ds_employeeWorkedTime,
                    ds_setCurrentDateEmployeeWorkedTime, ds_startTaskProgressLoad, ds_startProjectTasksLoad,
                    ds_setCurrentProjectFotoInfo, ds_startWeatherLoad, ds_projectWeatherList, ds_setCurrentWeather,
                    ds_dataOperationStatus, ds_resetDataOperationStatus, ds_lastError,
                    ds_dialogOpen, ds_setDialogOpen,
                    // user data/fn exports
                    ds_isLoggedIn, ds_loggedinUser, ds_crrUserIsAdmin,
                    ds_loginUser, ds_logoutCurrentUser,
                    ds_userOperationStatus, ds_resetUserOperationStatus
                    }}>
                    {props.children}</AppDataContext.Provider>;
}

//------------------------------------------------------------------
export function UiProvider({ children }) {
    const [isNavBarOpen, setNavBarOpen] = useState(true);
    const uiValue = [{
        isNavBarOpen,
    }, {
        toggleNavBar: () => setNavBarOpen(!isNavBarOpen),
    }];
    return <UiContext.Provider value={uiValue}>{children}</UiContext.Provider>;
}

//------------------------------------------------------------------
export const useAppDataStore = () => useContext(AppDataContext);
export const useUiStore = () => useContext(UiContext);